import { Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSButton from "../../../Components/Button/WSButton";
// import BannerImage from '../../../FrontEnd/Images/Banner/1.jpg'

import { callAPI, clearRequest, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { Header } from "../../../Components/Header/Header";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSDateField from "../../../Components/DateField/WSDateField";
import dayjs from "dayjs";
import WSSelectField from "../../../Components/Select/WSSelect";
import clientConfig from '../../../Config/clientConfig.json'
import WSRadioField from "../../../Components/Radio/WSRadio";
export const Promotion: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const id = params?.id;
  const [defaultImg, setDefaultImg] = useState<any | null>(null);
  const [startDate, setStartDate] = useState<string>()

  useEffect(
    () => () => {
      reset();
    },
    []
  );
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getPromotionById(id: any) {
      try {
        const response: any = await callAPI(`Promotion`, Method.GET, {}, id);
        console.log("response", response);

        if (response && response?.data) {

          setValue("name", response.data.name);
          setDefaultImg(response.data?.filePath)
          setValue("startDate", dayjs(response.data?.startDate).format('DD/MM/YYYY'));
          setValue("endDate", dayjs(response.data?.endDate).format('DD/MM/YYYY'));
          setValue("category", response.data.category);
          setValue("id", response.data.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getPromotionById(id);
    }
  }, [id, setValue]);

  /**
   * Method for Add/Update the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
      console.log("Submitted data:", data);
      // Extract image name from the uploaded file.
      let imageName = "";
      if (data.imageUrl && data.imageUrl[0]) {
        const file = data.imageUrl[0]; // Assuming `imageUrl` contains an array of files.
        imageName = file.name; // Get the file name from the uploaded image.
      }
      const filePath = data.filePath || "";
      const startDate = dayjs(data.startDate, "DD/MM/YYYY").format('YYYY-MM-DDTHH:mm:ss.SSS')
      const endDate = dayjs(data.endDate, "DD/MM/YYYY").format('YYYY-MM-DDTHH:mm:ss.SSS')
      const formData = new FormData()
      formData.append("file", selectedFile!);
      formData.append("name", data.name); // Add title
      // formData.append("filePath",data.filePath); 
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);
      formData.append("category", data.category);

      // const newRequest = clearRequest(request)
      if (id) {
        formData.append("id", id); // Add display
        const response: any = await callAPI(`Promotion/${id}`, Method.PUTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response?.success === true) {
            callNotificationAPI(data.notificationType, data.category)
            navigate('/promotion/list')
          }
        }

      } else {
        const response: any = await callAPI("Promotion/Create", Method.POSTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response?.success === true) {
            callNotificationAPI(data.notificationType, data.category)
            navigate('/promotion/list')
          }
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };
  const callNotificationAPI = async (type: string, categoryId?: string) => {
    let notificationResponse: any = {};
    switch (type) {
      case 'SA':
        notificationResponse = await callAPI('Notifications/sendAll', Method.POST, { title: 'Metrofresh', body: "You have an offer!" });
        break;
      case 'SC':
        notificationResponse = await callAPI('Notifications/sendCategory', Method.POST, { title: 'Metrofresh', body: "You have an offer!", category: categoryId },);
        break;
    }
    return notificationResponse;

  }
  const handleCancelClick = () => {
    navigate('/promotion/list')
  }
  const handleUploadFile = (file: any) => {
    setDefaultImg(null)
    if (file && file.length > 0) {
      setSelectedFile(file[0]);
    }
  }
  const handleRemove = (id: string) => {
    alert(id)
  }

  const handleStartDateChange = (evt: any) => {
    setStartDate(evt)
  }
  const notificationOptios: any = [{ label: 'Send All', value: 'SA' }, { label: 'Send Category', value: 'SC' }];

  return (
    <>
      <Header type="simple" isDivider={true} title={`${id ? 'Edit' : 'Add'} Promotion`} url="/promotion/list" id={'promotionImg'} isBackButton={true} headerSx={{ marginTop: 0 }} />
      <form onSubmit={handleSubmit(handleData)}>
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3,
          }}
        >
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Name"}
                {...register("name")}
                id="name"
                name="name"
                control={control}
                rules={{ required: true }}
              // labelType="Normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSSelectField
                label={"Category"}
                {...register("category")}
                id="category"
                name="category"
                control={control}
                options={clientConfig.promotionCatConfig.staticOptionData}
                rules={{ required: true }}
              //   labelType="Normal"
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
            <WSTextField
              label={"File Path"}
              {...register("filePath")}
              id="filePath"
              name="filePath"
              control={control}
              rules={{ required: false }}
              labelType="Normal"
            />
          </Grid> */}
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="startDate"
                name="startDate"
                label={"Start Date"}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="past"
                onChange={handleStartDateChange}
                control={control}
                defaultValue={null}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="endDate"
                name="endDate"
                label={"End Date"}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                defaultValue={startDate}
                setValue={setValue}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <WSRadioField control={control} rules={{ required: true }} id="notificationType" name="notificationType" options={notificationOptios} align="Horizontal" defaultValue={'SA'} />
            </Grid>

            <Grid item sm={6} style={{ overflow: 'auto' }}>
              <WSFileUpload
                name="imageUrl"
                label="Image"
                control={control}
                rules={{ required: defaultImg ? false : true }}
                acceptFileTypes=".jpg,.jpeg,.png"
                maxFileSizeMB={2}
                defaultValue={defaultImg}
                id={"imageUrl"}
                image={true}
                onChange={handleUploadFile}
                onRemove={handleRemove}
                align="Start"
                isToolTipImg={false}
                multiple={false}
              />
            </Grid>
            <Grid item xs={12} sm={6} style={{ display: "none" }}>
              <WSHiddenField
                name="id"
                control={control}

              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "3rem",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <WSButton
                id="submit"
                label={"Save"}
                type="submit"
                size="medium"
              />
              <WSButton
                id="cancel"
                label={"Cancel"}
                type="button"
                onClick={handleCancelClick}
                size="medium"
                className="ws-cancel"
              />
            </Grid>
          </Grid>
        </Grid>
      </form>

    </>);
});
